import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar/navbar";
import Home from "./pages/home/home";
import HighlightEventPage from "./pages/hightlight_event/index";
import NewsletterPage from "./pages/newsletter_page";
import Login from "./pages/auth/admin";
import AdminPage from "./pages/auth/admin";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/anchoring_conversations"
          element={<HighlightEventPage />}
        />
        <Route path="/lighthouse" element={<NewsletterPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;
